<script>
import { mapActions } from 'vuex';
import { getStartPage } from '@/utils/api/contentful';
import Teaser from '@/components/shared/Teaser.vue';
import setMetaData from '@/utils/setMetaData';
import Note from '@/components/shared/Note.vue';

export default {
  name: 'HomeDocumentation',

  components: {
    Teaser,
    Note,
  },

  data() {
    return {
      teasers: [],
      note: {},
    };
  },

  async created() {
    this.setIsPageLoading(true);

    try {
      const page = await getStartPage();
      setMetaData({ title: '', description: '' });

      this.teasers = page ? page.fields.teasers : [];
      this.note = page ? page.fields.note : {};
    } catch (error) {
      console.error(error);
    }

    this.setIsPageLoading(false);
  },

  methods: {
    ...mapActions('settings', ['setIsPageLoading']),
  },
};
</script>

<template>
  <div class="page">
    <Note v-if="note && note.fields" :content="note.fields" type="large" />
    <Teaser v-for="teaser in teasers" :key="teaser.sys.id" :teaser="teaser.fields" size="large" />
  </div>
</template>

<style lang="scss" scoped>
.page {
  max-width: $page-width;
  @include page-padding;
}
</style>
